<template>
  <b-card>
    <b-row>
      <b-col cols="12">
        <h4 class="mb-2">{{ id ? 'Editar' : 'Cadastrar' }} Pesquisador</h4>
      </b-col>

      <b-col md="6">
        <b-form-group label="Nome Completo" label-for="fullName">
          <b-form-input
            id="fullName"
            v-model="form.fullName"
            placeholder="Nome Completo"
          />
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group label="Email" label-for="email">
          <b-form-input
            id="email"
            v-model="form.email"
            type="email"
            placeholder="email@exemplo.com"
          />
        </b-form-group>
      </b-col>

      <b-col md="12">
        <b-form-group label="Área do Pesquisador">
          <v-select
            v-model="selectedArea"
            :options="areaOptions"
            :reduce="val => val.value"
            label="text"
            placeholder="Selecione uma área"
          >
            <template #no-options>
              Nenhum resultado encontrado
            </template>
          </v-select>
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group label="Senha" label-for="password">
          <b-form-input
            id="password"
            v-model="form.password"
            type="password"
            placeholder="Senha"
          />
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group label="Confirmar Senha" label-for="confirmPassword">
          <b-form-input
            id="confirmPassword"
            v-model="form.confirmPassword"
            type="password"
            placeholder="Confirmar Senha"
          />
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group label="Ativo">
          <b-form-checkbox
            v-model="form.active"
            name="check-button"
            switch
            inline
          >
            {{ form.active ? 'Sim' : 'Não' }}
          </b-form-checkbox>
        </b-form-group>
      </b-col>

      <b-col cols="12" class="mt-2">
        <b-button
          variant="primary"
          class="mr-1"
          @click="submitForm"
        >
          Salvar
        </b-button>
        <b-button
          variant="outline-secondary"
          :to="{ name: 'PesquisadorLista' }"
        >
          Cancelar
        </b-button>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BButton,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { hideSpinner, showSpinner } from '@/services/spinService'
import pesquisadorService from '@/services/pesquisadorService'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    vSelect,
  },
  props: {
    id: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      form: {
        id: null,
        fullName: '',
        email: '',
        areas: [],
        password: '',
        confirmPassword: '',
        active: true,
      },
      areaOptions: [
        { text: 'Educação', value: 'Educacao' },
        { text: 'Tecnologia da Informação', value: 'TecnologiaDaInformacao' },
        { text: 'Laboratório e Entomologia', value: 'LaboratorioEEntomologia' },
      ],
    }
  },
  computed: {
    selectedArea: {
      get() {
        return this.form.areas && this.form.areas.length > 0 ? this.form.areas[0] : null
      },
      set(val) {
        this.form.areas = val ? [val] : []
      },
    },
  },
  async mounted() {
    if (this.$route.params.id) {
      await this.fetchResearcher()
    }
  },
  methods: {
    async fetchResearcher() {
      showSpinner()
      try {
        const data = await pesquisadorService.getById(this.$route.params.id)
        this.form = {
          ...data,
          password: '',
          confirmPassword: '',
        }
      } catch (error) {
        console.error('Erro ao buscar pesquisador:', error)
      } finally {
        hideSpinner()
      }
    },
    async submitForm() {
      if (this.form.password !== this.form.confirmPassword) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro',
            icon: 'AlertTriangleIcon',
            text: 'As senhas não conferem',
            variant: 'danger',
          },
        })
        return
      }

      showSpinner()
      try {
        if (this.form.id) {
          await pesquisadorService.update(this.form)
        } else {
          await pesquisadorService.create(this.form)
        }

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Sucesso',
            icon: 'CheckIcon',
            text: 'Pesquisador salvo com sucesso',
            variant: 'success',
          },
        })
        this.$router.push({ name: 'PesquisadorLista' })
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro',
            icon: 'AlertTriangleIcon',
            text: error.response.data.message || 'Erro ao salvar pesquisador',
            variant: 'danger',
          },
        })
      } finally {
        hideSpinner()
      }
    },
  },
}
</script>
